import Principal from '../screens/Principal.vue'
import Revisar from '../screens/Revisar.vue'
import CtTributacao from '../screens/CtTributacao.vue'
import Importar from '../screens/Importar.vue'
import Resultado from '../screens/Resultado.vue'
import MinhasNotas from '../screens/MinhasNotas'
export const routes = [     
    {path:'/reclef',name:'principal', component: Principal},    
    {path:'/reclef/revisar',name:'revisar', component: Revisar},    
    {path:'/reclef/regime',name:'regime', component: CtTributacao},    
    {path:'/reclef/importar',name:'importar', component: Importar}, 
    {path:'/reclef/consultas',name:'consulta', component: MinhasNotas}, 
    {path:'/reclef/resultado',name:'resultado', component: Resultado},    
];